
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { head } from 'lodash'

import LazyImg from '@xt/www/components/lazyImg/index.vue'

import type { AllMomentItem } from '@xt/client/entities/video-v2/controller'
import type { PublicCourseItem as TPublicCourseItem } from '@xt/client/entities/home-v2/public-course'

@Observer
@Component({
  components: { LazyImg }
})
export default class PublicCourseItem extends Vue {
  @Prop({ required: true }) data: AllMomentItem

  get formatedData(): null | TPublicCourseItem {
    if (!this.data) return null

    return {
      commentCount: this.data.commentCount,
      id: this.data.id,
      likeCount: typeof this.data.likeCount === 'number' ? this.data.likeCount : 0,
      liked: this.data.like === true,
      publishTime: this.data.createTime,
      title: this.data.title,
      summary: this.data.content,
      videoCoverUrl: head(this.data.pictures)?.originUrl ?? head(this.data.pictures)?.waterUrl ?? '',
      videoUrl: this.data.videoUrl,
      viewCount: typeof this.data.viewCount === 'number' ? this.data.viewCount : 0
    } satisfies TPublicCourseItem
  }

  @Emit('click')
  handleClick() {
    return this.formatedData?.id
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
